/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSalesforceDestinationComponent', [
    'DesignerBaseSourceAndDestinationComponent',
    'DesignerConnection',

    function (DesignerBaseSourceAndDestinationComponent, DesignerConnection) {
      function DesignerSalesforceDestinationComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.object_name = null;
        this.operation_type = null;
        this.id_field = null;
        this.batch_size = null;
        this.max_errors = null;
        this.track_errors = false;
        this.errors_output_connection = new DesignerConnection();
        this.errors_output_path = null;
        this.column_mappings = [];
        this.cloud_storage_connection_id = null;
      }

      DesignerSalesforceDestinationComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerSalesforceDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          object_name: this.object_name || this.defaults.object_name,
          operation_type: this.operation_type || this.defaults.operation_type,
          id_field: this.id_field || this.defaults.id_field,
          batch_size: this.batch_size || this.defaults.batch_size,
          parallel: this.parallel || this.defaults.parallel,
          max_errors: this.max_errors || this.defaults.max_errors,
          track_errors: this.track_errors || this.defaults.track_errors,
          enable_null_value: this.enable_null_value || this.defaults.enable_null_value,
          errors_output_connection: this.errors_output_connection.getData(),
          errors_output_path: this.errors_output_path || '',
          column_mappings: this.column_mappings || this.defaults.column_mappings,
          database_connection_id: String(this.connection.id),
        });

        if (!data.track_errors) {
          delete data.track_errors;
          delete data.errors_output_connection;
          delete data.errors_output_path;
        }

        return data;
      };

      DesignerSalesforceDestinationComponent.prototype.getFormData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getFormData.call(this);

        return data;
      };

      DesignerSalesforceDestinationComponent.prototype.setFormData = function (data) {
        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerSalesforceDestinationComponent.prototype.setData = function (data) {
        this.errors_output_connection.setData(data.errors_output_connection);
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.object_name = data.object_name;
        this.operation_type = data.operation_type;
        this.id_field = data.id_field;
        this.batch_size = Number(data.batch_size);
        this.parallel = Number(data.parallel);
        this.max_errors = Number(data.max_errors);
        this.column_mappings = data.column_mappings;
        this.cloud_storage_connection_id = data.cloud_storage_connection_id;
        this.errors_output_path = data.errors_output_path;
        this.track_errors = data.track_errors;
        this.enable_null_value = data.enable_null_value;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerSalesforceDestinationComponent.prototype.getSchema = function () {
        const schema = DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerSalesforceDestinationComponent;
    },
  ]);
})(window.angular);
